"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WHITE = '#ffffff';
var GRAY = '#333333';
var BLACK = '#000000';
var TRANSPARENT = 'transparent';
var ColorTones;
(function (ColorTones) {
    ColorTones[ColorTones["BRIGHT"] = 0] = "BRIGHT";
    ColorTones[ColorTones["DARK"] = 1] = "DARK";
    ColorTones[ColorTones["NONE"] = 2] = "NONE";
})(ColorTones || (ColorTones = {}));
//Using the HSL (hue, saturation and lightness) representation for RGB color values, if the value of the lightness is less than 20, the color is dark
var DARK_COLORS_LIGHTNESS = 20;
//If the value of the lightness is more than 80, the color is bright
var BRIGHT_COLORS_LIGHTNESS = 80;
var TRANSPARENT_COLOR = 'transparent';
/**
 * Set text color or background color to the given element
 * @param element The element to set color to
 * @param color The color to set, it can be a string of color name/value or a ModeIndependentColor object
 * @param isBackgroundColor Whether set background color or text color
 * @param isDarkMode Whether current mode is dark mode. @default false
 * @param shouldAdaptTheFontColor Whether the font color needs to be adapted to be visible in a dark or bright background color. @default false
 * @param defaultFontColor Set the default colors that needs to be set to the to be visible.
 */
function setColor(element, color, isBackgroundColor, isDarkMode, shouldAdaptTheFontColor) {
    var colorString = typeof color === 'string' ? color.trim() : '';
    var modeIndependentColor = typeof color === 'string' ? null : color;
    if (colorString || modeIndependentColor) {
        element.style.setProperty(isBackgroundColor ? 'background-color' : 'color', (isDarkMode
            ? modeIndependentColor === null || modeIndependentColor === void 0 ? void 0 : modeIndependentColor.darkModeColor
            : modeIndependentColor === null || modeIndependentColor === void 0 ? void 0 : modeIndependentColor.lightModeColor) || colorString);
        if (element.dataset) {
            var dataSetName = isBackgroundColor
                ? "ogsb" /* OriginalStyleBackgroundColor */
                : "ogsc" /* OriginalStyleColor */;
            if (!isDarkMode || color == TRANSPARENT_COLOR) {
                delete element.dataset[dataSetName];
            }
            else if (modeIndependentColor) {
                element.dataset[dataSetName] = modeIndependentColor.lightModeColor;
            }
        }
        if (isBackgroundColor && shouldAdaptTheFontColor) {
            adaptFontColorToBackgroundColor(element, isDarkMode);
        }
    }
}
exports.default = setColor;
/**
 * Change the font color to white or some other color, so the text can be visible with a darker background
 * @param element The element that contains text.
 */
function adaptFontColorToBackgroundColor(element, isDarkMode) {
    var _a;
    if ((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute('style')) {
        return;
    }
    var backgroundColor = element.style.getPropertyValue('background-color');
    var lightModeBackgroundColor = (isDarkMode &&
        (element.dataset["ogsb" /* OriginalStyleBackgroundColor */] ||
            element.dataset["ogab" /* OriginalAttributeBackgroundColor */])) ||
        backgroundColor;
    if (!lightModeBackgroundColor || lightModeBackgroundColor === TRANSPARENT) {
        return;
    }
    var isADarkOrBrightOrNone = isADarkOrBrightColor(lightModeBackgroundColor);
    switch (isADarkOrBrightOrNone) {
        case 1 /* DARK */:
            var fontForDark = {
                lightModeColor: WHITE,
                darkModeColor: GRAY,
            };
            setColor(element, fontForDark, false /*isBackground*/, isDarkMode);
            break;
        case 0 /* BRIGHT */:
            var fontForLight = {
                lightModeColor: BLACK,
                darkModeColor: WHITE,
            };
            setColor(element, fontForLight, false /*isBackground*/, isDarkMode);
            break;
    }
}
function isADarkOrBrightColor(color) {
    var lightness = calculateLightness(color);
    if (lightness < DARK_COLORS_LIGHTNESS) {
        return 1 /* DARK */;
    }
    else if (lightness > BRIGHT_COLORS_LIGHTNESS) {
        return 0 /* BRIGHT */;
    }
    return 2 /* NONE */;
}
/**
 * Calculate the lightness of HSL (hue, saturation and lightness) representation
 * @param color a RBG or RGBA COLOR
 * @returns
 */
function calculateLightness(color) {
    var _a, _b;
    var r;
    var g;
    var b;
    if (color.substring(0, 1) == '#') {
        _a = getColorsFromHEX(color), r = _a[0], g = _a[1], b = _a[2];
    }
    else {
        _b = getColorsFromRGB(color), r = _b[0], g = _b[1], b = _b[2];
    }
    // Use the values of r,g,b to calculate the lightness in the HSl representation
    //First calculate the fraction of the light in each color, since in css the value of r,g,b is in the interval of [0,255], we have
    var red = r / 255;
    var green = g / 255;
    var blue = b / 255;
    //Then the lightness in the HSL representation is the average between maximum fraction of r,g,b and the minimum fraction
    return (Math.max(red, green, blue) + Math.min(red, green, blue)) * 50;
}
function getColorsFromHEX(color) {
    if (color.length === 4) {
        color = color.replace(/(.)/g, '$1$1');
    }
    var colors = color.replace('#', '');
    var r = parseInt(colors.substr(0, 2), 16);
    var g = parseInt(colors.substr(2, 2), 16);
    var b = parseInt(colors.substr(4, 2), 16);
    return [r, g, b];
}
function getColorsFromRGB(color) {
    var colors = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    var r = parseInt(colors[1]);
    var g = parseInt(colors[2]);
    var b = parseInt(colors[3]);
    return [r, g, b];
}
//# sourceMappingURL=setColor.js.map